import { Video } from "lucide-react";
import { useState } from "react";
import { useStore } from "zustand";
import { coreStore } from "@/lib/stores/core-store";
import { uiStore } from "@/lib/stores/ui-store";
import { CallVideoGrid } from "./call-video-grid";
import { CustomControlBar } from "./custom-control-bar";
import { RoomOverlay } from "./room-overlay";
import { StageControlBar } from "./stage-control-bar";
import { StageVideoGrid } from "./stage-video-grid";

type PipCallContentProps = {
	hideHeader?: boolean;
};

export function PipCallContent({ hideHeader }: PipCallContentProps) {
	const activeChannel = useStore(uiStore, (state) => state.activeChannel);
	const room = useStore(uiStore, (state) => state.room);
	const channels = useStore(coreStore, (state) => state.channels);
	const [container, setContainer] = useState<HTMLDivElement | null>(null);

	if (!(activeChannel && room)) {
		return null;
	}

	const channelData = channels.get(activeChannel.id);
	const isStageChannel = channelData?.type === "stage";
	const participantCount = room.remoteParticipants.size + 1;

	return (
		<div
			className="flex h-full w-full flex-col overflow-hidden bg-card"
			ref={setContainer}
		>
			{!hideHeader && (
				<div className="flex shrink-0 items-center justify-between border-b bg-card px-3 py-2">
					<div className="flex items-center gap-2">
						<Video className="size-3.5 text-primary" />
						<span className="truncate font-medium text-foreground text-sm">
							{activeChannel.name}
						</span>
					</div>
					<span className="shrink-0 text-muted-foreground text-xs">
						{participantCount} participant
						{participantCount !== 1 ? "s" : ""}
					</span>
				</div>
			)}
			{isStageChannel ? (
				<StageVideoGrid channelId={activeChannel.id} variant="compact" />
			) : (
				<CallVideoGrid variant="compact" />
			)}
			<RoomOverlay />
			{isStageChannel ? (
				<StageControlBar channelId={activeChannel.id} compact />
			) : (
				<CustomControlBar compact container={container} />
			)}
		</div>
	);
}
